var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item){return _c('div',{key:item.companyId},[_vm._v(_vm._s(item.companyTypeName)+"："+_vm._s(item.companyName))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }